import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"; // Assuming you're using Reactstrap for modals
import { getAgreementStatus, getParticipantSignedUrls, getSignedApplicationUrl, updateApplication } from "../../api/Applications";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import { formStatus } from "./Constant";

const AdobeSignatureModel = ({ signerModelShow, toggleModal, signerData, application, getApplication, getAgreementList, setActiveTableTab }) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  const [signedUrl, setSignedUrl] = useState(null);
  const [adobeSignData, setAdobeSignData] = useState();
  // Fetch the signed URL
  const getSignUrl = async () => {
    try {
      setIsLoaded(true); // Set loading state true while fetching
      const res = await getSignedApplicationUrl({
        values: { pdfUrl : signerData.formFile.signedUrl, filename:  signerData.formTitle },
        dispatch,
        token
      });

      if (res?.status === "SUCCESS") {
        setSignedUrl(res.data.url); // Set signed URL
        setAdobeSignData(res.data);
        setIsLoaded(true);
      } else {
        throw new Error(res?.message || "Failed to fetch signed URL");
      }
    } catch (error) {
      failed(error.message);
    } finally {
      setIsLoaded(false); // Reset loading state after fetching
    }
  };

  const handleUpdateAgreement = async() => {
    setIsLoaded(true);
    let res;
      try {
        const response = await getParticipantSignedUrls({
          values: { agreementId: adobeSignData?.agreementId },
          dispatch,
          token
        });

        // Assuming response.data is an array of signing URLs (one per signer)
        const signingUrls = response.data;

        // Map signers to signing URLs if you have access to signer info
        const participants = signingUrls?.map((signer, index) => ({
          phone: signer.phone || null,
          email: signer.email || null,
          esignUrl: signer.esignUrl || null
        }));

        const updatedApplicationForm = application.applicationForms.map((form) => {
          if (form.formId === signerData.formId) {
            return {
              ...form,
              agreementId: adobeSignData?.agreementId,
              status: formStatus.WAITING_FOR_SIGNATURE,
              participants
            };
          }
          return form;
        });
      const values = {applicationForms : updatedApplicationForm , formId: signerData.formId};
      res = await updateApplication({values, dispatch, token, applicationId: application._id});
      if (res?.status === "SUCCESS") {
          setIsLoaded(false);
          await getApplication();
          await getAgreementList();
          await setActiveTableTab("activeSignature");
      }else {
          setIsLoaded(false);
          failed(res?.message);
      }
      toggleModal();
    } catch (error) {
      failed(res?.message);
      setIsLoaded(false);
    }
  };

  const handleCheckAgreementStatus = async () => {
    if(!adobeSignData?.agreementId){
      toggleModal();
      return;
    }
    try {
      setIsLoaded(true); // Set loading state true while fetching
      const res = await getAgreementStatus({
        values: { agreementId : adobeSignData?.agreementId },
        dispatch,
        token
      });

      if (res?.status === "SUCCESS") {
        if(res.data.status === "OUT_FOR_SIGNATURE"){
         await handleUpdateAgreement();
        }else{
          toggleModal();
        }
      } else {
        throw new Error(res?.message || "Failed to fetch signed URL");
      }
    } catch (error) {
      failed(error.message);
    } finally {
      setIsLoaded(false); // Reset loading state after fetching
    }
  };

  // Fetch signed URL when pdfUrl changes
  useEffect(() => {
    if (signerData?.formFile?.signedUrl) {
       getSignUrl(); // Trigger signed URL fetch
    }else{
      failed("ERROR : Does not contain document.");
    }
  }, [signerData]);

  return (
    <Modal isOpen={signerModelShow} size="xl">
      <ModalHeader className="assign_blk p-0 mb-3">
        Add Signer
      </ModalHeader>
      <ModalBody className="form-add">
        {isLoaded ?
          <Loader/>
        : (
          signedUrl && (
            <iframe
              src={signedUrl} // Use the signed URL here
              width="100%"
              height="700px"
              frameBorder="0"
              title="PDF Viewer"
            ></iframe>
          )
        )}
      </ModalBody>
      <ModalFooter>
        <div className="d-flex justify-content-between">
          <Button color="secondary" onClick={()=>handleCheckAgreementStatus()}  className="save_btn cancel_btn">
            Close
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AdobeSignatureModel;
